export default ({ request }) => ({

  myQuotationListApi(data) {
    return request({
      url: '/digitalCenter/quotation/list',
      method: 'post',
      data
    })
  },
  myQuotationDetailApi(data) {
    return request({
      url: '/digitalCenter/quotation/detail',
      method: 'post',
      data
    })
  },
  myQuotationMainSaveApi(data) {
    return request({
      url: '/digitalCenter/quotation/quotationMainSave',
      method: 'post',
      data
    })
  },
  myQuotationItemSaveApi(data) {
    return request({
      url: '/digitalCenter/quotation/quotationItemSave',
      method: 'post',
      data
    })
  },
  myQuotationItemListApi(data) {
    return request({
      url: '/digitalCenter/quotation/quotationItemList',
      method: 'post',
      data
    })
  },
  // 报价单模板列表
  myQuotationExportTemplateListApi(custCode) {
    return request({
      url: '/export/quotaionExport/exportTemplateList/' + custCode,
      method: 'post'
    })
  },
  // 我的报价单 导出excel ppt接口
  exportExcel(url = '', data = {}) {
    return request({
      url: url,
      method: 'post',
      data,
      responseType: 'blob'
    })
  },
  myQuotationExportPPTAPi(data) {
    return request({
      url: '/export/quotationPptExport/execExport',
      method: 'post',
      data
    })
  },
})
